module.exports = __webpack_public_path__ + "static/media/Organik 2.622d7605.jpg";